import { render, staticRenderFns } from "./CourseManagement.vue?vue&type=template&id=023ce6df&scoped=true&"
import script from "./CourseManagement.vue?vue&type=script&lang=js&"
export * from "./CourseManagement.vue?vue&type=script&lang=js&"
import style0 from "./CourseManagement.vue?vue&type=style&index=0&id=023ce6df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ce6df",
  null
  
)

export default component.exports